import React from "react";

class Link extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        e.preventDefault();

        this.props.onLinkSelect(this.props.optionName);
    }

    render() {
        return <a className="link" onClick={this.handleClick}>
            {this.props.icon}
        </a>
    }
}

export default (Link);